import { Flex } from '@approvalmax/ui/src/components';
import { compareHelpers } from '@approvalmax/utils';
import { memo, useMemo } from 'react';

import { BudgetListItem } from '../BudgetListItem/BudgetListItem';
import { BudgetListProps } from './BudgetList.types';

export const BudgetList = memo<BudgetListProps>((props) => {
    const { budgets, isBudgetSyncEnabled } = props;

    const sortedBudgets = useMemo(() => {
        return [...budgets].sort((a, b) => {
            if (a.isEnabled !== b.isEnabled) {
                return a.isEnabled ? -1 : 1;
            }

            if (a.periodTill.asDateTime !== b.periodTill.asDateTime) {
                return compareHelpers.dateComparator2Desc(a.periodTill.asDateTime, b.periodTill.asDateTime);
            }

            return compareHelpers.stringComparator2Asc(a.name, b.name);
        });
    }, [budgets]);

    return (
        <Flex container aria-label='List of budgets'>
            {sortedBudgets.map((budget) => (
                <BudgetListItem key={budget.budgetId} budget={budget} isBudgetSyncEnabled={isBudgetSyncEnabled} />
            ))}
        </Flex>
    );
});

BudgetList.displayName = 'BudgetList';
